import * as XLSX from 'xlsx';

/**
 * Serialize already-prepared rows (built server-side) into an .xlsx and trigger
 * a browser download. This does NO filtering — the server returns the full
 * filtered dataset and this only writes it to a file.
 */
export function downloadXlsx(rows: Record<string, unknown>[], sheetName: string, filename: string): void {
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  // Excel sheet names are capped at 31 chars and disallow a few characters.
  const safeSheet = sheetName.replace(/[\\/?*[\]:]/g, ' ').slice(0, 31) || 'Sheet1';
  XLSX.utils.book_append_sheet(workbook, worksheet, safeSheet);
  XLSX.writeFile(workbook, filename);
}

export function dateStamp(): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
